import React from 'react';
import { Col, Row } from 'react-bootstrap';
import AgentCollectionHistoryComponent from '../Component/AgentCollectionHistoryComponent/AgentCollectionHistoryCoponent';
import AgentWalletHistoryComponent from '../Component/AgentWalletHistoryComponent/AgentWalletHistoryComponent';

function AgentWalletHistoryPage() {
    return (
        <>
            <Row>
                {/* wallet history */}
                <Col md={12}>
                    <AgentWalletHistoryComponent />
                </Col>

            </Row>
        </>
    );
}

export default AgentWalletHistoryPage;